<div class="ai-chat-mobile" [class.empty]="!messages.length">
  @if(messages.length) {
    <div class="ai-chat-mobile__map">
      @if(isFetchingMap) {
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%', margin: '0'}"></ngx-skeleton-loader>
      } @else {
        <app-preview-map
          [countryCoordinates]="countryCoordinates"
          [destinationsRoute]="destinationsRoute"
        ></app-preview-map>
      }
    </div>
    <div class="ai-chat-mobile__panel-overview">
      <ng-container [ngTemplateOutlet]="messagesTemplate"></ng-container>
    </div>
  } @else {
    <div class="ai-chat-mobile__header">
      <h2 class="ai-chat-mobile__header--title">Chat with AI</h2>
      <p class="ai-chat-mobile__header--description">To optimize the AI plan, use RoutePerfect Optimizer.</p>
    </div>

    <div class="ai-chat-mobile__content empty">
      <ng-container [ngTemplateOutlet]="newMessageTemplate"></ng-container>
    </div>

    <div class="ai-chat-mobile__footer"></div>
  }
</div>

<ng-template #messagesTemplate>
  <div class="ai-chat-mobile__actions">
    <button class="btn-default btn-orange ai-chat-mobile__actions--plan"
            [disabled]="!messages.length || isFetchingAnswer"
            (click)="submitCustomizeAiTrip()">
      Make it My Plan
    </button>
  </div>
  <div class="ai-chat-mobile__messages" #messagesList>
    @for (message of messages; let idx = $index; track idx) {
      <div class="ai-chat-mobile__message" [@questionInAnimation]>
        @if (userProfile) {
          <span class="ai-chat-mobile__message--avatar">
            {{ userProfile.name[0] }}
          </span>
        } @else {
          <img class="avatar-img chat" alt="Routeperfect AI" src="assets/svg/ic-chat-user.svg">
        }
        <p class="ai-chat-mobile__message--text">{{ message.question }}</p>
      </div>

      <div [id]="'element-id-' + idx" [@answerInAnimation] class="ai-chat-mobile__message">
        <span class="ai-chat-mobile__message--avatar">
          AI
        </span>
        <p class="ai-chat-mobile__message--text"
           [class.typewriter]="message.typewriting"
           [innerHTML]="message.answer"
        ></p>
      </div>
    }
  </div>
</ng-template>

<ng-template #newMessageTemplate>
  <div class="ai-chat-mobile__new">
    <h1 class="ai-chat-mobile__new--title">Describe your ideal trip below and get your AI plan.</h1>
    <p class="ai-chat-mobile__new--description">You can use one of the following examples:</p>

    <div class="ai-chat-mobile__new--messages">
      @for(example of examples; track example) {
        <button class="btn-default ai-chat-mobile__new--message" (click)="aiChatInputMobileComponent.setExample(example)">
          {{example}}
        </button>
      }
    </div>
  </div>
</ng-template>
